function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-width: 1.2px;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_87",
  "data-name": "Rectangle 87",
  className: "cls-1",
  width: 29.628,
  height: 22.768
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_235",
  "data-name": "Group 235"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_234",
  "data-name": "Group 234",
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  className: "cls-3",
  d: "M365.83,117.64h6.155V120.3",
  transform: "translate(-342.674 -110.194)"
})));

var _ref4 = /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  className: "cls-3",
  x2: 7.176,
  transform: "translate(11.183 7.446)"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_237",
  "data-name": "Group 237"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_236",
  "data-name": "Group 236",
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  className: "cls-3",
  d: "M7.2,122.947l1.79,8.4a1.72,1.72,0,0,0,1.612,1.3H28.4a1.72,1.72,0,0,0,1.612-1.3l2.164-10.148H5v-3.554h6.111",
  transform: "translate(-4.684 -110.194)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  className: "cls-3",
  x2: 5.112,
  y2: 8.854,
  transform: "translate(16.742 0.316)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  className: "cls-3",
  x1: 5.112,
  y2: 8.854,
  transform: "translate(7.773 0.316)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_13",
  "data-name": "Line 13",
  className: "cls-3",
  x1: 1.335,
  y2: 6.335,
  transform: "translate(21.928 13.447)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_14",
  "data-name": "Line 14",
  className: "cls-3",
  x1: 0.667,
  y2: 6.335,
  transform: "translate(18.374 13.447)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_15",
  "data-name": "Line 15",
  className: "cls-3",
  x1: 0,
  y2: 6.335,
  transform: "translate(14.814 13.447)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_16",
  "data-name": "Line 16",
  className: "cls-3",
  x2: 0.667,
  y2: 6.335,
  transform: "translate(10.587 13.447)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_17",
  "data-name": "Line 17",
  className: "cls-3",
  x2: 1.112,
  y2: 6.335,
  transform: "translate(6.365 13.447)"
})));

var SvgBasketIcon = function SvgBasketIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Basket_Icon",
    "data-name": "Basket Icon",
    width: 29.628,
    height: 22.768,
    viewBox: "0 0 29.628 22.768",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasketIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BasketIcon.f3c7bf90.svg";
export { ForwardRef as ReactComponent };